import React from "react";

import { useTranslation } from "utils";

import { Icon } from "components";

export const PasswordStrengthPopup = ({ currentPasswordStrength }) => {
  const { t } = useTranslation(["signinup"]);

  const PasswordStrengthEntry = ({ checked, text }) => (
    <div className="icon-row white-text margin-top-50 margin-bottom-0">
      <Icon iconName={checked ? "tabler/circle-check" : "tabler/circle"} className="icon inline normal" />
      <span className="white-text">{text}</span>
    </div>
  );

  return (
    <>
      <h5 className="white-text">{t("password.tips.criteria")}</h5>

      {currentPasswordStrength.password !== currentPasswordStrength.checkPassword || currentPasswordStrength.password === "" ? (
        <PasswordStrengthEntry text={t("password.tips.match")} />
      ) : (
        <PasswordStrengthEntry checked text={t("password.tips.match")} />
      )}

      {currentPasswordStrength.length < 6 ? (
        <PasswordStrengthEntry text={t("password.tips.length")} />
      ) : (
        <PasswordStrengthEntry checked text={t("password.tips.length")} />
      )}

      <h5 className="white-text margin-top-100">{t("password.tips.criteria")}</h5>

      {!currentPasswordStrength.lowercase ? (
        currentPasswordStrength.strength < 1 && <PasswordStrengthEntry text={t("password.tips.lowercase")} />
      ) : (
        <PasswordStrengthEntry checked text={t("password.tips.lowercase")} />
      )}
      {!currentPasswordStrength.uppercase ? (
        currentPasswordStrength.strength < 1 && <PasswordStrengthEntry text={t("password.tips.uppercase")} />
      ) : (
        <PasswordStrengthEntry checked text={t("password.tips.uppercase")} />
      )}
      {!currentPasswordStrength.number ? (
        currentPasswordStrength.strength < 1 && <PasswordStrengthEntry text={t("password.tips.number")} />
      ) : (
        <PasswordStrengthEntry checked text={t("password.tips.number")} />
      )}
      {!currentPasswordStrength.symbol ? (
        currentPasswordStrength.strength < 1 && <PasswordStrengthEntry text={t("password.tips.symbol")} />
      ) : (
        <PasswordStrengthEntry checked text={t("password.tips.symbol")} />
      )}
    </>
  );
};
